//Global Imports
import clsx from "clsx";
import React, { useState } from "react";
import { Controller, useForm } from "react-hook-form";
//End Global Imports

//Local Imports
import TextFieldNew from "../../../components/ui/TextField/TextFieldNew";
import Button from "../../../components/ui/Button";
import { getErrorMessage, regexForPassword } from "../../../utils";
import Tooltip from "../../../components/ui/Tooltip";
import { DoubleVerifiedIcon } from "../../../assets/Icons";
//End Local Imports

const StepThreeNew = ({ saveNewPassword, email }: any) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  // const [showConfirmTooltip, setShowConfirmTooltip] = useState(false);
  const labelStyle = "xl:text-[28px] lg:text-[20px] font-semibold text-[#000] xl:mb-6 lg:mb-3";

  type FormInputs = {
    password: string;
    confirmPassword: string;
  };

  const {
    formState: { errors },
    handleSubmit,
    getValues,
    control,
  } = useForm<FormInputs>();

  const handlePasswordBlur = () => {
    setShowTooltip(false);
  };

  // const handleConfirmPasswordBlur = () => {
  //   setShowConfirmTooltip(false);
  // };

  const handlePasswordChange = (value: string) => {
    if (value?.length > 0) {
      const patternMatch = regexForPassword.test(value);
      if (!patternMatch) {
        setShowTooltip(true);
      } else {
        setShowTooltip(false);
      }
    }
  };

  const PasswordValidator = ({ password, email }: { password: string; email: string }) => {
    // Validation checks
    const validations = [
      {
        label: "Should be min. 8 words",
        valid: password.length >= 8,
      },
      {
        label: "Should contain special characters",
        valid: /[!@#$%^&*(),.?":{}|<>]/.test(password),
      },
      {
        label: "Should not be same as email ID",
        valid: password && email && password != email,
      },
      {
        label: "Should contain atleast one uppercase letter",
        valid: /[A-Z]/.test(password),
      },
      {
        label: "Should contain atleast one lowercase letter",
        valid: /[a-z]/.test(password),
      },
    ];

    return (
      <div className="flex flex-wrap gap-2 mt-3">
        {validations.map((rule, idx) => (
          <div
            key={idx}
            className={`flex items-center px-3 py-1 rounded-full text-sm font-medium ${rule.valid ? "bg-green-700 text-white" : "bg-red-700 text-white"
              }`}
          >
            {rule.valid ? "✔✔" : "✘"} {rule.label}
          </div>
        ))}
      </div>
    );
  };

  return (
    <form
      onSubmit={handleSubmit(saveNewPassword)}
      className="flex flex-col items-start"
    >
      <div className={clsx(labelStyle)}>Create New Password</div>
      <div className="w-full">
        <div className="w-full relative">
          <Controller
            control={control}
            name="password"
            rules={{ required: true, pattern: regexForPassword }}
            render={({ field: { name, value, onChange } }) => {
              return (
                <>
                  <p className="xl:text-xl lg:text-base font-medium text-[#000] mb-2">New Password <span className="text-red-100">*</span></p>
                  <TextFieldNew
                    name={name}
                    type="password"
                    placeholder="Enter new password"
                    inputClasses={clsx(errors.password ? "border-red-100" : "border border-[#D9D9D9]/100 border-[0.5px]", "flex xl:!h-[40.104px] lg:!h-[35.105px] px-4 justify-between items-center self-stretch rounded-[12px] bg-[#fff] !text-[#000] !pt-0")}
                    placeholderStyle="text-[#9e9e9e] font-normal xl:text-base lg:text-sm font-inter !top-[0.55rem]"
                    value={value}
                    onChange={(e) => {
                      const value = e.target.value;
                      handlePasswordChange(value);
                      onChange(e);
                      setPassword(value);
                    }}
                    onBlur={handlePasswordBlur}
                    error={errors.password}
                    // eslint-disable-next-line
                    errorMessage={getErrorMessage(
                      errors as Record<string, { type: any }>,
                      "password",
                      "Password",
                    )}
                    autoComplete="off"
                    fullWidth
                  />
                </>
              );
            }}
          />
          {showTooltip && (
            // <Tooltip
            //   positionOfTip="bottom"
            //   bgColor="bg-secondary-800"
            //   tooltipStyles="!bottom-auto pb-4 md:pb-0 xl:mt-[22%] lg:mt-[22%] md:mt-[22%] sm:mt-[30%] xs:mt-[35%] mt-30% absolute"
            // >
            //   <div className="z-20 px-5 py-4 rounded-md sm:w-[372px] w-fit">
            //     <div className="pb-[10px] text-black font-ssp font-bold text-sm">
            //       Password criteria
            //     </div>
            //     <div className="flex items-center pb-2 text-sm font-normal font-ssp text-primary">
            //       <span className="mr-1">
            //         <DoubleVerifiedIcon />
            //       </span>
            //       Should be 8 words atleast
            //     </div>
            //     <div className="flex items-center pb-2 text-sm font-normal font-ssp text-error">
            //       <span className="mr-1">
            //         <DoubleVerifiedIcon fillColor="stroke-error" />
            //       </span>
            //       Should contain the special characters @$#+*
            //     </div>
            //     <div className="flex items-center pb-2 text-sm font-normal font-ssp text-grey-600">
            //       <span className="mr-1">
            //         <DoubleVerifiedIcon fillColor="stroke-grey-600" />
            //       </span>
            //       Should not be same as your email
            //     </div>
            //     <div className="flex items-center pb-2 text-sm font-normal font-ssp text-primary">
            //       <span className="mr-1">
            //         <DoubleVerifiedIcon />
            //       </span>
            //       Should contain atleast one uppercase letter
            //     </div>
            //     <div className="flex items-center pb-2 text-sm font-normal font-ssp text-error">
            //       <span className="mr-1">
            //         <DoubleVerifiedIcon fillColor="stroke-error" />
            //       </span>
            //       Should contain atleast one lowercase letter
            //     </div>
            //   </div>
            // </Tooltip>
            <PasswordValidator password={password} email={email} />
          )}
        </div>
      </div>
      <div className="w-full my-4">
        <Controller
          control={control}
          name="confirmPassword"
          rules={{
            required: true,
            validate: {
              sameAs: () => {
                return getValues("password") === getValues("confirmPassword");
              },
            },
          }}
          render={({ field: { name, value, onChange } }) => {
            return (
              <>
                <p className="xl:text-xl lg:text-base font-medium text-[#000] mb-2">Confirm New Password <span className="text-red-100">*</span></p>
                <TextFieldNew
                  name={name}
                  type="password"
                  placeholder="Confirm new password"
                  inputClasses={clsx(errors.password ? "border-red-100" : "border border-[#D9D9D9]/100 border-[0.5px]", "flex xl:!h-[40.104px] lg:!h-[35.105px] px-4 justify-between items-center self-stretch rounded-[12px] bg-[#fff] !text-[#000] !pt-0")}
                  placeholderStyle="text-[#9e9e9e] font-normal xl:text-base lg:text-sm font-inter !top-[0.55rem]"
                  value={value}
                  onChange={(v) => {
                    const value = v.target.value;
                    onChange(v);
                    setConfirm(value);
                    // setShowConfirmTooltip(true);
                  }}
                  error={errors.confirmPassword}
                  // eslint-disable-next-line
                  errorMessage={getErrorMessage(
                    errors as Record<string, { type: any }>,
                    "confirmPassword",
                    "Confirm Password",
                  )}
                  // onBlur={handleConfirmPasswordBlur}
                  fullWidth
                  autoComplete="off"
                />
                {/* {showConfirmTooltip && (
                <PasswordValidator password={confirm} email={email} />
                )} */}
              </>
            );
          }}
        />
      </div>
      <div className="flex justify-center w-full mb-2">
        <Button
          bgColor="bg-primary-1050"
          fontStyle={{
            fontFamily: "font-ssp",
            fontSize: "xl:text-base lg:text-sm",
            fontWeight: "font-bold",
            fontColor: "text-white",
          }}
          borderStyle={{
            borderRadius: "rounded-lg",
          }}
          disabled={
            password == "" || confirm == "" || password != confirm 
          }
          className="w-full xl:h-[40px] lg:h-[40px] disabled:cursor-not-allowed disabled:opacity-50"
        >
          Confirm
        </Button>
      </div>
    </form>
  );
};

export default StepThreeNew;
